<template>
	<div class="extend_box animate__animated animate__fadeIn">
		<div class="extend">
			<div class="search_box">

                <div class="box_line">
                	<div class="title_txts">广联达项目编码：</div>
                	<input type="text" class="input_box" placeholder="请输入广联达项目编码" v-model="formData.gldProjectCode" />
                </div>
                <div class="box_line">
                	<div class="title_txts">广联达AppId：</div>
                	<input type="text" class="input_box" placeholder="请输入广联达AppId" v-model="formData.gldAppId" />
                </div>
                <div class="box_line">
                	<div class="title_txts">广联达Secret：</div>
                	<input type="text" class="input_box" placeholder="请输入广联达Secret" v-model="formData.gldSecret" />
                </div>

				<div class="box_line" v-if="APP.fnCheckRegion('28')">
					<div class="title_txts">人社项目编码：</div>
					<input type="text" class="input_box" placeholder="请输入人社项目编码" v-model="formData.cqMohrssProjectId" />
				</div>

                <div v-if="APP.fnCheckRegion('31')">
                    <div class="box_line">
                        <div class="title_txts">建委项目编码：</div>
                        <input type="text" class="input_box" placeholder="请输入建委项目编码" v-model="formData.cq2ProjectCode" />
                    </div>
                    <div class="box_line">
                        <div class="title_txts">建委集成商名称：</div>
                        <input type="text" class="input_box" placeholder="请输入建委集成商名称" v-model="formData.cq2DeviceFactory" />
                    </div>
                    <div class="box_line">
                        <div class="title_txts">建委集成商AppSecret：</div>
                        <input type="text" class="input_box" placeholder="请输入建委集成商AppSecret" v-model="formData.cq2AppSecret" />
                    </div>
                    <div class="box_line">
                        <div class="title_txts">建委集成商授权码：</div>
                        <input type="text" class="input_box" placeholder="请输入建委集成商授权码" v-model="formData.cq2DeviceAuthCode" />
                    </div>
					<div class="box_line">
					    <div class="title_txts">建委企业AppSecret：</div>
					    <input type="text" class="input_box" placeholder="请输入建委企业AppSecret" v-model="formData.cq2QyAppSecret" />
					</div>
					<div class="box_line">
					    <div class="title_txts">建委企业授权码：</div>
					    <input type="text" class="input_box" placeholder="请输入建委企业授权码" v-model="formData.cq2QyDeviceAuthCode" />
					</div>
                    <div class="box_line" v-if="is_admin">
                        <div class="title_txts">建委账号：</div>
                        <input type="text" class="input_box" placeholder="请输入建委账号" v-model="formData.cq2Username" />
                    </div>
                    <div class="box_line" v-if="is_admin">
                        <div class="title_txts">建委密码：</div>
                        <input type="text" class="input_box" placeholder="请输入建委密码" v-model="formData.cq2Password" />
                    </div>
                    <div class="box_line" v-if="is_admin">
                        <div class="title_txts">建委登录类型：</div>
                        <el-radio-group v-model="formData.cq2Type">
                            <el-radio label="P">个人用户</el-radio>
                            <el-radio label="L">企业用户</el-radio>
                        </el-radio-group>
                    </div>
                    <div class="box_line" v-if="is_admin">
                        <div class="title_txts">上传建委教育培训：</div>
                        <el-radio-group v-model="formData.cq2UploadWorkerEducationTrain">
                            <el-radio label="0">不开启</el-radio>
                            <el-radio label="1">开启</el-radio>
                        </el-radio-group>
                    </div>
                    <div class="box_line" v-if="is_admin">
                        <div class="title_txts">上传建委酒精血压：</div>
                        <el-radio-group v-model="formData.cq2JJXY">
                            <el-radio label="0">不开启</el-radio>
                            <el-radio label="1">开启</el-radio>
                        </el-radio-group>
                    </div>
                </div>

				<div class="box_line">
					<div class="search-btn" @click="fnBind" type="primary" v-if="APP.fnCheckRegion('28')"><span>绑定人社平台</span></div>
					<div class="search-btn" @click="fnAddOrEdit" type="primary"><span>保 存</span></div>
				</div>
			</div>
		</div>

    </div>
</template>
<script>
import request from '@/utils/request';
import { fnRequestPlatform } from '@/utils/upload';
import { getUserInfo } from '@/utils/auth';
import APP from '@/utils/base';
    import {
        cq2EncryptSM2
    } from '@/utils/sm2security';
export default {
	data() {
		return {
            APP: APP,
			key_group: {},
			formData: {
                gldProjectCode: '',
                gldAppId: '',
                gldSecret: '',
				cqMohrssProjectId: '',
                cq2ProjectCode: '',
                cq2DeviceFactory: '',
                cq2AppSecret: '',
                cq2DeviceAuthCode: '',
				cq2QyAppSecret: '',
				cq2QyDeviceAuthCode: '',
                cq2Username: '',
                cq2Password: '',
                cq2UsernameEncryption: '',
                cq2PasswordEncryption: '',
                cq2Type: 'P',
                cq2UploadWorkerEducationTrain: '0',
                cq2JJXY: '0'
			},
		};
	},
	created() {
		let userInfo = getUserInfo();
		this.is_admin = userInfo.is_admin ? true : false;
		this.fnGroup();
	},
	methods: {
		fnGroup() {
			request({
				url: 'project/getProjectInfo',
				method: 'GET'
			})
				.then(res => {
					this.key_group = JSON.parse(res.data.key_group);
					for (let _key in this.formData) {
						this.formData[_key] = this.key_group[_key];
					}
				})
				.catch(err => {
					this.$message.error(err.data);
				});
		},
		fnAddOrEdit() {
            if (this.formData.cq2Username) {
                this.formData.cq2UsernameEncryption = cq2EncryptSM2(this.formData.cq2Username)
            }

            if (this.formData.cq2Password) {
                this.formData.cq2PasswordEncryption = cq2EncryptSM2(this.formData.cq2Password)
            }
            let _data = JSON.stringify(this.key_group) == '[]' ? {} : this.key_group;
            Object.assign(_data, this.formData);
			request({
			        url: 'project/editProject',
			        method: 'POST',
			        data: {
			            key_group: JSON.stringify(_data)
			        }
			    })
			    .then(res => {
			        this.$message.success(res.data);
			    })
			    .catch(err => {
			        this.$message.error(err.data);
			    });
		},
        fnBind(){
            fnRequestPlatform(
              {
                url: '/CqMohrss/bind_project',
                method: 'GET'
              },
              res => {
                if (res.code == 1) {
                  this.$message.success(res.data);
                } else {
                  this.$message.warning(res.data);
                }
              }
            );
        }
	}
};
</script>
<style lang="scss" scoped>
@import '~@/styles/mixin.scss';
.extend_box {
	width: 1920px;
	height: 858px;
	position: relative;
	overflow: hidden;
	.extend {
		position: absolute;
		left: 0;
		right: -20px;
		top: 0;
		bottom: 0;
		overflow-x: hidden;
		overflow-y: auto;
	}
}
.search_box {
	height: 148px;
	width: 1880px;
	margin-top: 100px;
	margin-left: 20px;
	.box_line {
		width: 1880px;
		height: 72px;
		margin-bottom: 10px;
		@include flex-box(center, center);
		.title_txts {
			width: 170px;
			color: #fff;
			font-size: 18px;
		}
		.input_box {
			width: 311px;
			height: 40px;
			line-height: 30px;
			padding-left: 15px;
			color: rgba(77, 180, 244, 0.7);
			font-size: 12px;
			border-radius: 5px;
			outline: none;
			background-color: rgba(77, 180, 244, 0.2);
			border: none;
			&::-webkit-input-placeholder {
				color: rgba(77, 180, 244, 0.7);
			}
			&::-moz-placeholder {
				/* Mozilla Firefox 19+ */
				color: rgba(77, 180, 244, 0.7);
			}
			&:-moz-placeholder {
				/* Mozilla Firefox 4 to 18 */
				color: rgba(77, 180, 244, 0.7);
			}
			&:-ms-input-placeholder {
				/* Internet Explorer 10-11 */
				color: rgba(77, 180, 244, 0.7);
			}
		}
	}
}

.dialog_choose {
	.line_item {
		margin: 5px;
		height: 20px;
		line-height: 20px;
		color: rgba(255, 255, 255, 0.8);
	}
	.btn_line {
		@include flex-box(center, center);
	}
	/deep/ .el-dialog {
        width: 910px;
        height: 630px;
		background-color: rgba(9, 17, 32, 1);
		border: 1px solid rgba(58, 116, 221, 1);
		.row-item {
			color: white;
		}
	}
	/deep/ .el-form-item__label {
		color: #4db4f4;
	}
	/deep/ .el-dialog__title {
		color: #4db4f4;
	}
	/deep/ .el-dialog__close {
		color: #4db4f4;
	}
    /deep/ .el-dialog {
        width: 910px;
        height: 630px;
    }
	.cont_list {
		width: 860px;
		height: 425px;
		color: #ffffff;
		font-size: 16px;
		border-radius: 10px;
		margin: 0;
		background-color: rgba(29, 68, 149, 0.1);
		.list_title {
			width: 860px;
			height: 48px;
			background: url(../../../assets/img/per_list_bg.png) no-repeat;
			background-size: 100% 100%;
			@include flex-box(flex-start, center);
			.title_item {
				height: 48px;
				@include flex-box(center, center);
				&:nth-child(1) {
					width: 300px;
					margin-right: 2px;
					margin-left: 30px;
				}
				&:nth-child(2) {
					width: 190px;
					margin: 0 2px;
				}
				&:nth-child(3) {
					width: 310px;
					margin: 0 2px;
				}
				.select {
					width: 20px;
					height: 20px;
					border: 1px solid #65a6dd;
					border-radius: 2px;
					cursor: pointer;
					@include prefixCss3(transition, border-color 0.2s);
					&:hover {
						border-color: #409eff;
					}
					&.active {
						background-color: #409eff;
						border-color: #409eff;
						&::after {
							content: '';
							display: block;
							width: 100%;
							height: 100%;
							@include set-bg-img('../../../assets/images/icon-yes.png');
						}
					}
				}
			}
		}
		.list_boxes {
			width: 800px;
			height: 375px;
			margin-left: 30px;
			position: relative;
			overflow: hidden;
			.list_box {
				position: absolute;
				left: 0;
				right: -25px;
				top: 0;
				bottom: 0;
				overflow-x: hidden;
				overflow-y: auto;
				.box_line {
					width: 800px;
					height: 70px;
					margin: 5px 0 0 0px;
					border-bottom: 1px dashed #1d4495;
					@include flex-box(flex-start, center);
					&:hover {
						background-color: rgba(49, 88, 128, 0.4);
					}
					.list_item {
						height: 70px;
						text-align: center;
						@include flex-box(center, center);
						&:nth-child(1) {
							width: 300px;
							margin-right: 2px;
						}
						&:nth-child(2) {
							width: 200px;
							margin: 0 2px;
						}
						&:nth-child(3) {
							width: 300px;
							margin: 0 2px;
						}
						.select {
							width: 20px;
							height: 20px;
							border: 1px solid #65a6dd;
							border-radius: 2px;
							cursor: pointer;
							@include prefixCss3(transition, border-color 0.2s);
							&:hover {
								border-color: #409eff;
							}
							&.active {
								background-color: #409eff;
								border-color: #409eff;
								&::after {
									content: '';
									display: block;
									width: 100%;
									height: 100%;
									@include set-bg-img('../../../assets/images/icon-yes.png');
								}
							}
						}
					}
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/views/ProjectKey/projectKeyGld/index.vue